import { actionTypes } from './constants';

type Action<T extends actionTypes, P> = {
    type: T;
    payload: P;
};

type WebContentLoadingsData = {
    webContentId: string;
    isLoading: boolean;
}

export const setIsStickyFooter = (isStickyFooter: boolean): Action<actionTypes.SET_IS_STICKY_FOOTER, boolean> => ({
    type: actionTypes.SET_IS_STICKY_FOOTER,
    payload: isStickyFooter
});

export const setIsStickyHeader = (isStickyHeader: boolean): Action<actionTypes.SET_IS_STICKY_HEADER, boolean> => ({
    type: actionTypes.SET_IS_STICKY_HEADER,
    payload: isStickyHeader
});

export const setWebContentLoadings = (data: WebContentLoadingsData)
    : Action<actionTypes.SET_WEB_CONTENT_LOADINGS, WebContentLoadingsData> => ({
    type: actionTypes.SET_WEB_CONTENT_LOADINGS,
    payload: data
});

export const setFooterClassName = (footerClassName: string): Action<actionTypes.SET_FOOTER_CLASSNAME, string> => ({
    type: actionTypes.SET_FOOTER_CLASSNAME,
    payload: footerClassName
});
